import { useOutletContext } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';
import { AskInsightsPanel } from '@/components/admin/insights/AskInsightsPanel';

export default function AskInsights() {
  const { orgId } = useOutletContext<{ orgId: string }>();
  const [params] = useSearchParams();
  const initialQuestion = params.get('q') ?? undefined;

  return (
    <div className="space-y-6 max-w-4xl">
      <div>
        <h2 className="text-2xl font-heading font-semibold">Ask</h2>
        <p className="text-sm text-muted-foreground">
          Ask a plain-English question across surveys, pulses, and conversations. All answers use
          k≥5 aggregated data — never raw responses. Download any answer as a PDF report.
        </p>
      </div>

      <AskInsightsPanel scope={{ orgId, initialQuestion }} />
    </div>
  );
}
